import { useEffect , useState } from 'react'
import useProductCard from 'newHooks/useProductCard'
import ProductModal from 'newComponents/ProductsModal/ProductTC'
import ProductsSuccessAdd from '../ProductSuccessAdd'

const ProductsResp = (props) => {
    const {
        item,
        resettUrl
    } = props

    const {
        producto,
        productTC,
        idEvent,
        successUpdate,
        setSuccessUpdate,
        clickAddProduct,
        clickAddProductTC,
        clickModalProduct,
    } = useProductCard({item})

    const handleClose = () => {
        clickModalProduct( {showModal: false} )
        resettUrl()
    }

    useEffect(()=>{
        if(producto){
            if(producto?.variations){
                clickModalProduct( {
                    showModal: true,
                    productVariant: producto
                } )
            }else{
                clickModalProduct( {
                    showModal: true,
                    producto
                } )
            }
        }else{
            console.log('no hay producto')
        }
    },[producto?.variations])

    useEffect(()=>{
        if(productTC === undefined){
            clickModalProduct( {showModal: false} )
            resettUrl()
        }
    },[productTC])

    const [ success, setSuccess ] = useState(false)
    useEffect(()=>{
        if(successUpdate){
            setSuccess(true)
            setSuccessUpdate(false)
        }
    },[successUpdate])


    const isMobile = 'desktop'
    const imagen = item?.pictures ? item?.pictures[0]?.source : 'https://resources.sears.com.mx/medios-plazavip/swift/v1/assets/img/noImage.png' 


    return(
        <>
            <ProductModal
                modalTC={!!producto?.variations}
                handleClose={handleClose}
                isMobile={isMobile}
                title={isMobile === 'desktop' ? 'Promociones' : 'Promociones Sanborns'} 
                product={productTC}
                clickAddProduct={producto?.variations ? clickAddProductTC : clickAddProduct }
                image={imagen}
            />
            {success
                ?
                    <ProductsSuccessAdd
                        success={success}
                        setSuccess={setSuccess}
                        resettUrl={resettUrl}
                    />
                : null
            }
        </>
    )
}

export default ProductsResp